<template>
  <v-app style="background-color:#f5f5f5">
    <div class="login-banner"></div>
    <v-content style="margin-top:100px;">
      <v-card class="mx-auto" max-width="500" style="padding:20px 55px;">
        <v-layout class="d-flex flex-column pl-2 pr-2" jusity-content="center" align-items="center">
          <v-card-subtitle style="text-align:center;color:black;font-size:large;">SHIPMENT MANAGEMENT SYSTEM
          </v-card-subtitle>
          <v-text-field autofocus placeholder="Username" v-model="username"></v-text-field>
          <v-text-field
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPassword ? 'text' : 'password'"
              @click:append="showPassword = !showPassword"
              :error-messages="erroMessage"
              v-model="password"
              placeholder="Password"
          ></v-text-field>
          <v-checkbox dense hide-details label="REMEMBER ME"></v-checkbox>
        </v-layout>
        <v-card-actions
            class="d-flex flex-column pl-2 pr-2"
            jusity-content="center"
            align-items="center"
        >
          <v-btn
              tile
              color="primary"
              :loading="$store.getters.actionLoading"
              large
              style="width:120px;"
              @click="doLogin"
          >SIGN IN
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-content>
  </v-app>
</template>
<script>

export default {
  name: "v-login",
  data: function () {
    return {
      showPassword: false,
      username: null,
      password: null,
      erroMessage: null
    };
  },
  methods: {
    doLogin: function () {
      let params = {
        userName: this.username,
        password: this.password
      };
      this.$request.request("APP_LOGIN", params, {returnFullResponse: true}).then(response => {
        if (response.data.code == 'ok') {
          let user = Object.assign({}, response.data.data);
          localStorage.setItem("token", user.token);
          this.storeUserInfo(user);
          window.location.href = "./";
        } else {
          this.loginFailed(response.data.message);
        }
      });
    },
    storeUserInfo(user) {
      let userProfile = {
        id: user.userId,
        uid: user.userId,
        role: user.role,
        displayName: user.displayName,
        origin: user
      }
      localStorage.setItem("profile", JSON.stringify(userProfile));
    },
    loginFailed(message) {
      this.erroMessage = message;
      localStorage.clear();
    }
  }
};
</script>
